<template>
  <input
      type="text"
      name={nome}
      placeholder={segnaposto}
      disabled={disabilitato}
      aria-label={attributi.etichetta}
      autocomplete={autocompletamento}
      maxlength={lunghezza_massima}
      bind:value={valore}
      on:keydown
      on:input
      on:focus
      on:blur/>
</template>

<script>
  export let nome = ""
  export let valore = ""
  export let segnaposto = ""
  export let disabilitato = false
  export let attributi = {}
  export let lunghezza_massima = null
  export let passo = null
  export let disabilita_scroll_numero = false

  let autocompletamento = attributi.autocompletamento == false ? "off" : attributi.autocompletamento || "on"

  // Per compatibilità con altri inserimenti.
  attributi
  passo
  disabilita_scroll_numero
</script>
